/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import { fileNameEWS } from '../Miscellaneous/export';
import useStore from '../../../store';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function QuarterlyExcelSummarizedReportSFP({ object = null, ...props }) {
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const year = urlParams.get('year') ?? new Date().getFullYear();
	const currentLang = useStore((state) => state.currentLang);

	const labels = object?.labels || [];

	const tables = useMemo(() => {
		if (!object) return [];

		const list = [];
		if (object?.q1Cells?.length) list.push({ key: 'Q1', tableCells: object?.q1Cells });
		if (object?.q2Cells?.length) list.push({ key: 'Q2', tableCells: object?.q2Cells });
		if (object?.q3Cells?.length) list.push({ key: 'Q3', tableCells: object?.q3Cells });
		if (object?.q4Cells?.length) list.push({ key: 'Q4', tableCells: object?.q4Cells });
		if (object?.totalCells?.length) list.push({ key: 'TOTAL', tableCells: object?.totalCells });

		return list;
	}, [object]);

	const data = useMemo(() => {
		if (!labels.length || !tables.length) return [];

		return labels?.map((label, rowIdx) => {
			const row = {
				title: currentLang === 'kh' ? label?.titleKhmer : label?.titleEnglish,
			};

			tables?.forEach((table) => {
				const q = table?.key;
				const usd = table?.tableCells?.[rowIdx]?.[0]?.value ?? '';
				const khr = table?.tableCells?.[rowIdx]?.[1]?.value ?? '';

				row[`${q}_USD`] = usd;
				row[`${q}_KHR000`] = khr;
			});

			return row;
		});
	}, [labels, tables, currentLang]);

	return (
		<Box {...props}>
			<ExcelFile
				filename={fileNameEWS(`${year}_Quarter SFP Summarized Report`, null, null)}
				element={
					<Button
						isDisabled={!labels.length || !tables.length}
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				<ExcelSheet data={data} name="SFP">
					<ExcelColumn label={t('Label')} value="title" />

					{tables?.map((shownQuarter) => {
						const quarter = shownQuarter?.key;
						return [
							<ExcelColumn label={`${quarter}_USD`} value={`${quarter}_USD`} />,
							<ExcelColumn label={`${quarter}_KHR'000`} value={`${quarter}_KHR000`} />,
						];
					})}
				</ExcelSheet>
			</ExcelFile>
		</Box>
	);
}
